import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Panel } from 'primereact/panel';
import AccountAndRespondentInformation from './AccountAndRespondentInformation';
import { Link } from 'react-router-dom';
import AssessmentsAndRespondentsCount from './AssessmentAndRespondentsCount';
import GroupedJobProfiles from './GroupedJobProfiles';
import { AccountContext } from '../../../../components/AccountContext';

const GenericDashboard = ({ dashboardData }) => {
  const {
    accountData,
    respondentData,
    dashboard: { respondentsCount, assessmentsCount, assessmentsByStatus, jobsCount, jobsByAssessmentTemplate },
  } = dashboardData;

  const currentAccount = useContext(AccountContext);
  const {
    user: { firstName },
  } = useSelector((state) => state.app);

  const jobProfileListURL = `/accounts/${currentAccount}/job-profiles`;

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="wrapper brand-detailed-wrapper">
          <div className="section-title">
            <h1 data-t="header">
              <FormattedMessage id="dashboard.welcome" defaultMessage="Welcome">
                {(text) => <span>{text}, </span>}
              </FormattedMessage>
              {firstName}
            </h1>

            <FormattedMessage id="account.overview" defaultMessage="Account overview">
              {(text) => <p>{text}</p>}
            </FormattedMessage>
          </div>
          <div className="section-body">
            <div className="p-grid">
              <div className="p-col-12 p-md-8">
                <Panel
                  header={
                    respondentsCount ? (
                      <FormattedMessage id="candidate.plural">
                        {(text) => `${respondentsCount} ${text}`}
                      </FormattedMessage>
                    ) : null
                  }
                >
                  <AssessmentsAndRespondentsCount
                    respondentsCount={respondentsCount}
                    assessmentsCount={assessmentsCount}
                    assessmentsByStatus={assessmentsByStatus}
                  />
                </Panel>
              </div>

              <div className="p-col-12 p-md-4">
                <Panel
                  header={
                    jobsCount ? (
                      <FormattedMessage id="job.plural">{(text) => `${jobsCount} ${text} `}</FormattedMessage>
                    ) : null
                  }
                >
                  <div className="panel-body">
                    {jobsCount ? (
                      <div data-t="jobs">
                        <FormattedMessage id="job.grouped" defaultMessage="Grouped Job Profiles">
                          {(text) => <p className="text-muted">{text}</p>}
                        </FormattedMessage>

                        <GroupedJobProfiles jobProfiles={jobsByAssessmentTemplate} />

                        <p className="center-block text-center">
                          <Link to={jobProfileListURL} className="btn btn-primary">
                            <FormattedMessage id="job.view" defaultMessage="View Job Profiles">
                              {(text) => <span>{text}</span>}
                            </FormattedMessage>
                          </Link>
                        </p>
                      </div>
                    ) : (
                      <div className="center-block text-center" data-t="jobs">
                        <FormattedMessage id="job.empty" defaultMessage="No Job Profiles">
                          {(text) => <p className="text-muted">{text}</p>}
                        </FormattedMessage>
                      </div>
                    )}
                  </div>
                </Panel>
                <br />
                <AccountAndRespondentInformation accountData={accountData} respondentData={respondentData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenericDashboard;
